function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#9AA2B8",
  fillRule: "evenodd",
  d: "M10 0a3 3 0 012.995 2.824L13 3v1h2a1 1 0 010 2h-1v7.75c0 1.221-1.024 2.168-2.265 2.245L11.57 16H4.43c-1.26 0-2.336-.896-2.423-2.092L2 13.75V6H1a1 1 0 01-.993-.883L0 5a1 1 0 011-1h2V3A3 3 0 015.824.005L6 0h4zM4 6v7.75c0 .093.126.215.334.244L4.43 14h7.142c.232 0 .386-.11.421-.209L12 13.75V6H4zm6-4H6a1 1 0 00-.993.883L5 3v1h6V3a1 1 0 00-.883-.993L10 2z"
});

var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
};

export default SvgTrash;